import { React } from 'react';
import styled from 'styled-components';

import { useLanguage } from '../../../Context/LanguageContext';

import TopBar from './TopBar';
import LocationButton from './LocationButton';

function ServiceModel() {
  const { t } = useLanguage();

  return (
    <TopLevelWrapper>
      <TopBar />
      <BottomWrapper>
        <LocationButton nowPage={'Service'} />
        <TextWrapper>
          <Title style={{ marginTop: `38px` }}>{t('rules.service.t1')}</Title>
          <Bold style={{ marginTop: `14px` }}>{t('rules.service.b1')}</Bold>
          <Text>{t('rules.service.p1')}</Text>


          <Title style={{ marginTop: `38px` }}>{t('rules.service.t2')}</Title>
          <Text>
            {t('rules.service.p2')}
          </Text>
          <Text style={{ marginTop: `14px` }}>
            {t('rules.service.p3')}
          </Text>
          <Text style={{ marginTop: `14px` }}>
            {t('rules.service.p4')}
          </Text>

          <Title style={{ marginTop: `38px` }}>{t('rules.service.t3')}</Title>
          <Text>
            {t('rules.service.p5')}
          </Text>
          <Text style={{ marginTop: `14px`}}>
            {t('rules.service.p6')}
          </Text>
          <Text>
            {t('rules.service.p7')}
          </Text>

          <Title style={{ marginTop: `38px` }}>{t('rules.service.t4')}</Title>
          <Text>
            {t('rules.service.p8')}
          </Text>
          <Text style={{ marginTop: `14px`}}>
            {t('rules.service.p9')}
          </Text>
          <Text>
            {t('rules.service.p10')}
          </Text>
          <Text style={{ marginTop: `14px`}}>
            {t('rules.service.p11')}
          </Text>
          <Text>
            {t('rules.service.p12')}
          </Text>
          <Text style={{ marginTop: `14px`}}>
            {t('rules.service.p13')}
          </Text>
          <Text style={{ marginTop: `14px`}}>
            {t('rules.service.p14')}
          </Text>
          <Text>
            {t('rules.service.p15')}
          </Text>

          <Title style={{ marginTop: `38px`}}>{t('rules.service.t5')}</Title>
          <Text>
            {t('rules.service.p16')}
          </Text>
          <Text style={{ marginTop: `14px`}}>
            {t('rules.service.p17')}
          </Text>

          <Title style={{ marginTop: `38px` }}>{t('rules.service.t6')}</Title>
          <Text>
            {t('rules.service.p18')}
          </Text>
          <Text>
            {t('rules.service.p19')}
          </Text>
          <Text style={{ marginTop: `14px` }}>
            {t('rules.service.p20')}
          </Text>
          <Text style={{ marginTop: `14px` }}>
            {t('rules.service.p21')}
          </Text>

          <Title style={{ marginTop: `38px` }}>{t('rules.service.t7')}</Title>
          <Text>
            {t('rules.service.p22')}
          </Text>
          <Text style={{ marginTop: `14px`}}>
            {t('rules.service.p23')}
          </Text>

          <Title style={{ marginTop: `38px` }}>{t('rules.service.t8')}</Title>
          <Text>
            {t('rules.service.p24')}
          </Text>
          <Text style={{ marginTop: `14px` }}>
            {t('rules.service.p25')}
          </Text>
          <Text style={{ marginTop: `14px` }}>
            {t('rules.service.p26')}
          </Text>
          <Text style={{ marginTop: `14px` }}>
            {t('rules.service.p27')}
          </Text>
          <Text style={{ marginTop: `14px` }}>
            {t('rules.service.p28')}
          </Text>
          <Text style={{ marginTop: `14px` }}>
            {t('rules.service.p29')}
          </Text>
          <Text style={{ marginTop: `14px` }}>
            {t('rules.service.p30')}
          </Text>
          <Text style={{ marginTop: `14px` }}>
            {t('rules.service.p31')}
          </Text>
          <Text style={{ marginTop: `14px` }}>
            {t('rules.service.p32')}
          </Text>


          <Title style={{ marginTop: `38px` }}>{t('rules.service.t9')}</Title>
          <Text>
            {t('rules.service.p33')}
          </Text>
          <Text style={{ marginTop: `14px`}}>
            {t('rules.service.p34')}
          </Text>
          <Text style={{ marginTop: `14px` }}>
            {t('rules.service.p35')}
          </Text>

          <Title style={{ marginTop: `38px` }}>{t('rules.service.t10')}</Title>
          <Text>
            {t('rules.service.p36')}
          </Text>
          <Text style={{ marginTop: `14px`}}>
            {t('rules.service.p37')}
          </Text>
          <Text style={{ marginTop: `14px`}}>
            {t('rules.service.p38')}
          </Text>


          <Title style={{ marginTop: `38px` }}>{t('rules.service.t11')}</Title>
          <Text>
            {t('rules.service.p39')}
          </Text>
          <Text style={{ marginTop: `14px` }}>
            {t('rules.service.p40')}
          </Text>


          <Title style={{ marginTop: `38px` }}>{t('rules.service.t12')}</Title>
          <Text>
            {t('rules.service.p41')}
          </Text>
          <Text style={{ marginTop: `14px`}}>
            {t('rules.service.p42')}
          </Text>
          <Text style={{ marginTop: `14px` }}>
            {t('rules.service.p43')}
          </Text>


          <Title style={{marginTop: `38px`}}>{t('rules.service.t13')}</Title>
          <Text>
            {t('rules.service.p44')}
          </Text>
          <Text style={{ marginTop: `14px` }}>
            {t('rules.service.p45')}
          </Text>
          <Text style={{ marginTop: `14px` }}>
            {t('rules.service.p46')}
          </Text>

          <Title style={{ marginTop: `38px` }}>{t('rules.service.t14')}</Title>
          <Text>
            {t('rules.service.p47')}
          </Text>
          <Text style={{ marginTop: `14px` }}>
            {t('rules.service.p48')}
          </Text>
          <Text>
            {t('rules.service.p49')}
          </Text>


          <Title style={{ marginTop: `38px` }}>{t('rules.service.t15')}</Title>
          <Text>
            {t('rules.service.p50')}
          </Text>
          <Text style={{ marginTop: `14px` }}>
            {t('rules.service.p51')}
          </Text>
          <Text style={{ marginTop: `14px` }}>
            {t('rules.service.p52')}
          </Text>
          <Text style={{ marginTop: `14px` }}>
            {t('rules.service.p53')}
          </Text>
          <Text style={{ marginTop: `14px` }}>
            {t('rules.service.p54')}
          </Text>
          <Text style={{ marginTop: `14px`}}>
            {t('rules.service.p55')}
          </Text>
          <Text>
            {t('rules.service.p56')}
          </Text>

          <Title style={{ marginTop: `14px`, marginBottom: `123px` }}>{t('rules.service.t16')}</Title>
        </TextWrapper>
      </BottomWrapper>
    </TopLevelWrapper>
  )
}

export default ServiceModel;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  // width: 1194px;
`;

const BottomWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 1194px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 14px;

  color: #FF8B48;

  margin: 0 0 0 0;
`;

const Bold = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 14px;

  color: #232323;

  margin: 0 0 0 0;
`;

const Text = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: #232323;

  margin: 0 0 0 0;
`;
